export { default as default } from './Player';
